import React from "react";
import ReactDOM from "react-dom";

class Portal extends React.Component<{ node?: Element }, {}> {
  //This class just provides an easier way to render a portal
  render() {
    const node = this.props.node || document.body;
    return ReactDOM.createPortal(this.props.children, node);
  }
}
export default Portal;
